import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Avatar, Button, Dropdown, Layout, Space } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PermissionKey, PUBLIC_ROUTE_KEYS } from "../../constants/permissions";
import { AppDispatch, RootState } from "../../store";
import { logoutUser } from "../../store/slices/authSlice";

const { Header } = Layout;

export interface DashboardHeaderProps {
  collapsed: boolean;
  onToggle: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  collapsed,
  onToggle,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { user, permissions } = useSelector((state: RootState) => state.auth);

  const handleLogout = async () => {
    try {
      localStorage.setItem("isUserLoggedOut", "true");
      await dispatch(logoutUser()).unwrap();
      navigate("/login");
    } catch (error) {
      navigate("/login");
    }
  };

  const userMenuItems: MenuProps["items"] = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "Profile",
      onClick: () => navigate("/dashboard/profile"),
    },
    {
      key: "LIST_CONFIGURATIONS",
      icon: <SettingOutlined />,
      label: "Settings",
      onClick: () => navigate("/dashboard/configurations"),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: handleLogout,
    },
  ];

  const filteredUserMenuItems = userMenuItems.filter((item) => {
    return permissions.some(
      (permission) =>
        permission.name === item?.key ||
        PUBLIC_ROUTE_KEYS.includes(item?.key as PermissionKey)
    );
  });

  return (
    <Header
      style={{
        padding: 0,
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        width: "100%",
      }}
    >
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={onToggle}
        className="trigger-button"
        style={{
          fontSize: "16px",
          width: 64,
          height: 64,
          border: "none",
        }}
      />
      <Space style={{ marginRight: 24 }}>
        <Dropdown
          menu={{ items: filteredUserMenuItems }}
          placement="bottomRight"
          trigger={["click"]}
          arrow={{ pointAtCenter: true }}
        >
          <Space
            className="user-dropdown"
            style={{ cursor: "pointer", padding: "0 8px" }}
          >
            <span
              style={{
                color: "rgba(0, 0, 0, 0.85)",
                marginLeft: 8,
              }}
            >
              {user?.name}
            </span>
            <Avatar icon={<UserOutlined />} />
          </Space>
        </Dropdown>
      </Space>
      <style>
        {`
          .trigger-button {
            transition: all 0.3s ease;
          }
          
          .trigger-button:hover {
            background: rgba(0, 0, 0, 0.025);
          }

          .user-dropdown {
            padding: 4px 8px;
            border-radius: 4px;
            transition: all 0.3s ease;
          }

          .user-dropdown:hover {
            background: rgba(0, 0, 0, 0.025);
          }
        `}
      </style>
    </Header>
  );
};

export default DashboardHeader;
